import userService from "./userService";
import { accessGuard, getServerURL } from "../shared/sharedFunctions";
import companyService from "./companyService";

const CompanyEmployeeService = () => {
	const pub = {};
	
	pub.companyEmployees = [];
	pub.selectedCompanyEmployee = null;
	pub.courseStats = null;
	pub.trainingReport = null;
	pub.groups = null;
	pub.riskHistory = null;
	
	const courseStatsCallbacks = [];
	
	pub.all = async () => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1, 2, 3])) reject(new Error("Unauthorised"));
		
			const company = companyService.selectedCompany;
			const companyId = company.id;
			
			const req = {
				method: "GET",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			};
			
			
			fetch(`${getServerURL()}/api/companyemployees/all/${companyId}`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then((data) => {
				if (data === undefined || !data || !data.hasOwnProperty("companyEmployees")) {
					throw new Error("invalid response from getting company employees");
				}
				
				pub.companyEmployees = data.companyEmployees;
				pub.courseStats = data.courseStats;
				pub.courseStats.sort((a, b) => { return a.label.localeCompare(b.label); });
				if (pub.selectedCompanyEmployee != null && !pub.companyEmployees.includes(pub.selectedCompanyEmployee)) {
					pub.selectedCompanyEmployee = (pub.companyEmployees.length > 0)? pub.companyEmployees[0] : null;
				}
				
				for (let i in courseStatsCallbacks) {
					courseStatsCallbacks[i]();
				}
				
				pub.groups = data.groups;
				
				pub.riskHistory = (data.riskHistory && data.riskHistory.usecure_data)?
					data.riskHistory.usecure_data : null;
			})
			.then(() => {
				if (company.usecure_id) {
					return fetch(
						`${getServerURL()}/api/companyemployees/trainingreport/${company.id}`,
						req
					)
				}
			})
			.then((response) => {
				if (!response) {
					return;
				}
				else if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then((data) => {
				if (!data) return;
				pub.trainingReport = data;
			})
			.then(() => {
				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
		
	};
	
	pub.add = (companyEmployee) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1, 2])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					company_id: companyEmployee.company_id,
					firstname: (companyEmployee.firstname && companyEmployee.firstname.trim().length > 0)?
						companyEmployee.firstname : null,
					lastname: (companyEmployee.lastname && companyEmployee.lastname.trim().length > 0)?
						companyEmployee.lastname : null,
					email: companyEmployee.email
				})
			};
			
			fetch(`${getServerURL()}/api/companyemployees/add`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then((data) => {
				if (data === undefined || !data || !data.hasOwnProperty("companyEmployee")) {
					throw new Error("invalid response from adding company employee");
				}
				companyEmployee = data.companyEmployee;
				
				return pub.all(companyService.selectedCompany.id);
			})
			.then(() => {
				return resolve(companyEmployee);
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	}
	
	pub.update = (companyEmployee) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1, 2])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "PUT",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					company_id: companyEmployee.company_id,
					firstname: (companyEmployee.firstname && companyEmployee.firstname.trim().length > 0)?
						companyEmployee.firstname : null,
					lastname: (companyEmployee.lastname && companyEmployee.lastname.trim().length > 0)?
						companyEmployee.lastname : null,
					email: companyEmployee.email
				})
			};
			
			fetch(`${getServerURL()}/api/companyemployees/update/${companyEmployee.id}`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then((data) => {
				if (data === undefined || !data || !data.hasOwnProperty("companyEmployee")) {
					throw new Error("invalid response from updating company employee");
				}
				companyEmployee = data.companyEmployee;
				
				return pub.all(companyService.selectedCompany.id);
			})
			.then(() => {
				return resolve(companyEmployee);
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.delete = (companyEmployee) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1, 2])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "DELETE",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() }
			};
			
			fetch(`${getServerURL()}/api/companyemployees/delete/${companyEmployee.id}`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(() => {
				return pub.all(companyService.selectedCompany.id);
			})
			.then(() => {
				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.subscribeCompanyToCourse = async (subscribed, courseId) => {
		try {
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					courseId: courseId,
					companyId: companyService.selectedCompany.id
				})
			};
			
			await fetch(`${getServerURL()}/api/jobs/subusecure/${subscribed}`, req);
			
			await pub.all(companyService.selectedCompany.id);
		}
		catch (e) {
			console.log(`error: ${e.message}`);
		}
	};
	
	pub.onCourseStats = (callback) => {
		let existingCallback = false;
		for (let i in courseStatsCallbacks) {
			if (courseStatsCallbacks[i] === callback) {
				existingCallback = true;
				break;
			}
		}
		
		if (!existingCallback) {
			courseStatsCallbacks.push(callback);
		}
	}
	
	pub.enrollAllOnCourse = async (courseId) => {
		try {
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					courseId: courseId,
					companyId: companyService.selectedCompany.id
				})
			};
			
			await fetch(`${getServerURL()}/api/jobs/enrollall`, req);
			
			await pub.all(companyService.selectedCompany.id);
		}
		catch (e) {
			console.log(`error: ${e.message}`);
		}
	};
	
	pub.getCurrentRiskScore = () => {
		let riskScore = 0;
		
		const riskHistory = (pub.riskHistory && pub.riskHistory.length >= 3)? pub.riskHistory[3] : null;
		if (riskHistory && riskHistory.data && riskHistory.data.length > 0) {
			const entry = riskHistory.data[riskHistory.data.length - 1];
			riskScore = entry.uLearnRiskScore;
		}
		
		return riskScore;
	};
	
	return pub;
};

export default CompanyEmployeeService();
